import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import ReactDOM from 'react-dom';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import _Select from '@material-ui/core/Select';
import { Input as _Input } from './index';
import _Switch from '@material-ui/core/Switch';
import { getThemeColorValue } from '../theme/color';
import { getId, invalid } from '../../utils/common';
import Tooltip from '../Tooltip';

function createSwitch({ width, height, transform, thumbSize }) {
  return withStyles((theme) => ({
    root: {
      width: width,
      height: height,
      padding: 0,
      display: 'flex',
    },
    switchBase: (props) => {
      return {
        padding: "2px !important",
        color: theme.palette.grey[500],
        '&$checked': {
          transform: `translateX(${transform}px)`,
          color: theme.palette.common.white,
          '& + $track': {
            opacity: "1!important",
            backgroundColor: getThemeColorValue(props["data-color"]),
            borderColor: `${getThemeColorValue(props["data-color"])}`,
          },
        },
      }
    },
    thumb: {
      width: thumbSize,
      height: thumbSize,
      boxShadow: 'none',
    },
    track: (props) => {
      return {
        border: `1px solid ${props.checked ? getThemeColorValue(props["data-color"]) : theme.palette.grey[500]}`,
        borderRadius: width / 2,
        opacity: "1!important",
        backgroundColor: theme.palette.common.white,
      }
    },
    checked: (props) => {
      return {
        padding: "2px !important",
        color: theme.palette.grey[500],
        '&$checked': {
          transform: `translateX(${transform}px)`,
          color: theme.palette.common.white,
          '& + $track': {
            opacity: "1!important",
            backgroundColor: getThemeColorValue(props["data-color"]),
            borderColor: getThemeColorValue(props["data-color"]),
          },
        },
      }
    },
  }))(_Switch);
}

const SmallAntSwitch = createSwitch({ width: 36, height: 20, transform: 15, thumbSize: 16 });
const MediumAntSwitch = createSwitch({ width: 42, height: 24, transform: 18, thumbSize: 20 });

export default class Switch extends _Input {

  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
    }
  }

  componentDidMount() {
    super.componentDidMount();
    if (invalid(this.props.value)) this.reset();
  }

  reset() {
    super.reset();
    this.set(0);
  }


  selfChange(e, v) {
    v = v ? 1 : 0;
    this.set(v);

    let { onClick } = this.props;
    if (onClick) onClick(v);
  }
  renderMain() {

  }

  renderCore(disabled, component) {
    let tip = this.getTip();

    return disabled
      ? Tooltip({
        description: tip,
        placement: "top",
        content: <div>{component}</div>
      })
      : component;
  }


  render() {
    let { label, readonly, className, style, size, color, value, editable } = this.props;
    let { error } = this.state;
    let help = this.help();
    let disabled = this.getDisabled();
    let ps = {
      checked:Boolean(_.isBoolean(value) ? Number(value) : parseInt(value) === 1),
      size,
      readOnly: readonly,
      disabled,
      "data-color": color,
      name: `switch_${getId()}`,
      onChange: (e) => { this.selfChange(e, e.target.checked); }
    }

    let component = size === "small" ? <SmallAntSwitch {...ps} /> : <MediumAntSwitch  {...ps} />;

    return (
      <FormControl className={this.getClassName("w-100 c-switch")} error={error ? true : false} disabled={disabled} >
        {this.tipComponent("switch", { fixed: true })}
        <div className={`d-flex flex-row align-items-center c-mh1d75 ${label ? "mt-2" : ""} ${className}`} style={{ ...style }}>
          {this.renderCore(disabled, component)}
        </div>
        {error || help ? <FormHelperText className={"mt-0"} >{error || help}</FormHelperText> : null}
      </FormControl >
    )
  }
}

Switch.defaultProps = {
  className: '',
  size: "medium",
  color: "primary"
}
